module.exports = __webpack_public_path__ + "static/media/youtube-white.8e4dde5c.svg";